module.exports = __webpack_public_path__ + "img/17_72.62931d70.png";